import { render, staticRenderFns } from "./AddMemberCourseModal.vue?vue&type=template&id=76e3752a"
import script from "./AddMemberCourseModal.vue?vue&type=script&lang=js"
export * from "./AddMemberCourseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports